import { render, staticRenderFns } from "./album-form.vue?vue&type=template&id=44722efe&"
import script from "./album-form.vue?vue&type=script&lang=js&"
export * from "./album-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports